import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const SectionService = sdk.getService('SectionService');

export const useSectionDetail = (sectionId: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['sections', sectionId],
    queryFn: () => SectionService.getSection(sectionId),
    enabled: !!sectionId
  });

  return {
    section: data,
    isLoading,
    error
  };
};
